import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { CommandPalette } from './CommandPalette';

export function CommandPaletteButton() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  
  // Detect platform for keyboard shortcut display
  const isMac = typeof navigator !== 'undefined' && navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const shortcutText = isMac ? '⌘K to search' : 'Ctrl+K to search';

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Disable backtick shortcut in integration editor
      if (location.pathname.startsWith('/ihub/integration/')) {
        return;
      }

      // Open/close command palette with Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen(prev => !prev);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, location.pathname]);

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setOpen(true)}
              className="flex items-center gap-2 text-lime hover:text-white hover:bg-gray-800/50 border-l rounded-none h-[3.5rem] w-[3.5rem]"
            >
              <Search className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>{shortcutText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      
      <CommandPalette open={open} onOpenChange={setOpen} />
    </>
  );
}
